import { createReducer } from 'app/utils/redux';
import { Record, Set } from 'immutable';
import { getAbilityById } from 'app/constants/enums/Ability';
import {
  LOAD, DONE,
  SET_USER, CLEAR_USER,
  SET_AUTH, CLEAR_AUTH,
} from 'app/models/auth/constants';
import { parseSupplementary } from 'app/remote';

export const Auth = new Record({
  isLoading: false,
  userId: undefined,
  totalAbilities: Set(),
  authenticatedAbilities: Set(),
  validUntil: undefined,
});

const INITIAL_STATE_AUTH = new Auth();

export const authReducers = createReducer(INITIAL_STATE_AUTH, {
  [DONE]: state => state.set('isLoading', false),
  [LOAD]: state => state.set('isLoading', true),
  [SET_USER]: (state, { payload }) => {
    if (!payload) {
      return state;
    } else {
      const userId = payload.data.id;
      // totalAbilities is the union of all a user's abilities from
      //  * abilities directly assigned to the user
      //  * abilities directly assigned to the user's staff member
      //  * abilities assigned to the user's staff member's role
      //
      // this is in contrast with the abilities field of a user which
      // is just those which were directly assigned to the user
      const totalAbilities = Set(
        (parseSupplementary(payload.meta, userId, 'total_abilities') || [])
          .map(getAbilityById),
      );
      // authenticatedAbilities is
      //   (totalAbilities union universalAbilities) intersection requestedScopes
      const authenticatedAbilities = Set(
        (parseSupplementary(payload.meta, userId, 'authenticated_abilities') || [])
          .map(getAbilityById),
      );
      return state.merge({ userId, totalAbilities, authenticatedAbilities });
    }
  },
  [SET_AUTH]: (state, { payload }) => {
    const { expires_in, received_at } = payload;
    const validUntil = received_at + expires_in;
    return state.merge({ validUntil });
  },
  [CLEAR_USER]: state => state.merge({
    userId: undefined,
    totalAbilities: Set(),
    authenticatedAbilities: Set(),
  }),
  [CLEAR_AUTH]: state => state.merge({
    validUntil: undefined,
  }),
});
